const inBrowser = typeof window !== 'undefined'

const inWeex = typeof WXEnvironment !== 'undefined'
const weexPlatform = inWeex

const UA = inBrowser && window.navigator.userAgent.toLowerCase()

export const isSafari = window.safari !== undefined

export const isAndroid =
  (UA && UA.indexOf('android') > 0) || weexPlatform === 'android'
export const isIOS =
  (UA && /iphone|ipad|ipod|ios/.test(UA)) || weexPlatform === 'ios'
